const mixin = {
  data () {
    return {
      meta: {
        title: this.$store.state.instructorModule.selectedInstructor.name,
        description: `${this.$store.state.instructorModule.selectedInstructor.name} offers guitar instruction in ${this.$store.state.instructorModule.selectedInstructor.vicinity}.  Lessons for beginners, hobbyists, and professionals. With Strumm, you can do your research on instructor before signing up for lessons. We also provide resources for instructors so they can focus on teaching their students, such as billing, scheduling, and finding new students.`,
        slug: this.$store.state.instructorModule.selectedInstructor.place_id
      }
    }
  },
  metaInfo () {
    const meta = this.meta
    return {
      title: meta ? `${meta.title} on Strumm` : 'Instructor Profile - Strumm',
      titleTemplate: null,
      meta: [
        // Open Graph / Facebook
        { vmid: 'og:title', property: 'og:title', content: meta ? `${meta.title} on Strumm` : 'Instructor Profile on Strumm' },
        { vmid: 'og:type', property: 'og:type', content: 'website' },
        { vmid: 'og:url', property: 'og:url', content: meta ? `https://www.strumm.co/instructor/${meta.slug}` : 'https://www.strumm.co/' },
        { vmid: 'og:description', property: 'og:description', content: meta ? meta.description : 'Lessons for beginners, hobbyists, and professionals. With Strumm, you can do your research on instructor before signing up for lessons. We also provide resources for instructors so they can focus on teaching their students, such as billing, scheduling, and finding new students.' },
        // { vmid: 'og:image', property: 'og:image', content: '' },
        // Twitter
        { vmid: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
        { vmid: 'twitter:url', property: 'twitter:url', content: meta ? `https://www.strumm.co/instructor/${meta.slug}` : 'https://www.strumm.co/' },
        { vmid: 'twitter:title', property: 'twitter:title', content: meta ? `${meta.title} on Strumm` : 'Instructor Profile on Strumm' },
        { vmid: 'twitter:description', property: 'twitter:description', content: meta ? meta.description : 'Lessons for beginners, hobbyists, and professionals. With Strumm, you can do your research on instructor before signing up for lessons. We also provide resources for instructors so they can focus on teaching their students, such as billing, scheduling, and finding new students.' }
        // { vmid: 'twitter:image', property: 'twitter:image', content: '' }
      ]
    }
  }
}
export default mixin
